import React from "react";
import { valueToString } from "helpers/Helpers";
import classNames from "classnames";
import BaseReportTable from "./BaseReportTable";

import "components/reportTable/reportTable.scss";
import moment from "moment";
import { formatReportCurrency } from "helpers/reportFormat";

interface IProps {
  data: Array<Record<string, any>>;
  columns: Array<Record<string, any>>;
  description: string;
  compileDate: string;
}

export default function ServerSummariesTable(props: IProps) {

  function formatDisplay(type: string, value: string) {
    let newValue = value !== null && value !== undefined ? value : "";

    if (!isNaN(Number(newValue)) && newValue !== "") {
      switch (type) {
        case "currency":
          newValue = formatReportCurrency(value);
          break;
        case "decimal":
          newValue = Number(value).toFixed(2);
          break;
        case "percentage":
          newValue = `${Number(value) * 100}%`;
          break;
        default:
          break;
      }
    } else if (typeof type === "string" && newValue !== "") {
      if (type === "datetime") {
        newValue = moment(value, "YYYY-MM-DD HH:mm:ss")?.format("LLL");
      } else {
        newValue = valueToString(value).replace(/(^\w|\s\w)/g, c => c.toUpperCase());
      }
    }

    return newValue;
  }

  // Format cell data based on column
  function cellData(columnId: string, cellValue: string, displayType: string, cell: any) {
    switch (columnId) {
      case "tournament_name":
        return cell.row?.original?.tournament_name
          ? formatDisplay(displayType, cell.row?.original?.tournament_name as string)
          : cell.row?.original?.hospitality_event_name
            ? formatDisplay(displayType, cell.row?.original?.hospitality_event_name as string)
            : formatDisplay(displayType, cellValue);
      default:
        return formatDisplay(displayType, cellValue);
    }
  }

  // Add on click events based on column
  function cellOnClick() {
    return {};
  }

  function cellClassNames(cell: any, isRowLocked: boolean) {
    return classNames({
      "report-table-row-locked": isRowLocked,
    });
  }

  // function isPaymentTypeColumn(columnId: string) {
  //   const column = props.columns?.find(column => column.id === columnId);
  //   const refundColumn = props.columns?.find(column => column.id === "refunds");

  //   if (column && refundColumn) {
  //     if (column.position > 5 && column.position < refundColumn.position) {
  //       return true;
  //     } else {
  //       return false;
  //     }
  //   }

  //   return false;
  // }

  // Add footer data based on column
  // function footerData(columnId: string, footerRow?: Record<string, any>) {
  //   if (!footerRow) {
  //     return null;
  //   }

  //   if (isPaymentTypeColumn(columnId)) {
  //     return formatDisplay(
  //       "currency",
  //       String(footerRow[columnId] ?? 0),
  //     );
  //   }

  //   switch (columnId) {
  //     case "admin_name":
  //       return footerRow?.admin_name as string;

  //     case "sales":
  //     case "refunds":
  //     case "tips":
  //     case "cash_tip":
  //       return formatDisplay(
  //         "currency",
  //         String(footerRow[columnId] ?? 0),
  //       );

  //     default:
  //       return footerRow[columnId] as string ?? null;
  //   }
  // }

  return (
    <BaseReportTable
      data={props.data}
      columns={props.columns}
      description={props.description}
      compileDate={props.compileDate}
      cellOnClick={cellOnClick}
      cellData={cellData}
      cellClassNames={cellClassNames}
      footerData={() => {}}
      expanding={false}
    />
  );
}
